import { KeyValueToken } from '@/src/types/generics';
import { CategoryLandingPage, SearchRuleEntry } from '@/types/contentStack';

export function agnosticReplaceTokens(
    template: string | undefined,
    tokens: KeyValueToken[],
): string {
    // If the template is undefined, return an empty string.
    if (!template) {
        return '';
    }
    // If there are no tokens, save time and return the template as is.
    if (tokens.length === 0) {
        return template;
    }

    // Iterate over each token object
    tokens.forEach(token => {
        // For each key-value pair within the token object
        for (const key in token) {
            // Replace occurrences of the key with its corresponding value
            template = template!.replace(
                new RegExp(key, 'g'),
                token[key] as string,
            );
        }
    });

    return template;
}

export function isCategoryEntry(
    entry: SearchRuleEntry | CategoryLandingPage | undefined,
): entry is CategoryLandingPage {
    return !!entry && !entry.hasOwnProperty('search_page_title');
}

export function isSearchRuleEntry(
    entry: SearchRuleEntry | CategoryLandingPage | undefined,
): entry is SearchRuleEntry {
    return !!entry && 'search_page_title' in entry;
}
